<template>
  <!--
      作者：huangyi
      时间：2023-05-2
      描述：提现详情
  -->
  <div class="pb50" v-loading="loading">
    <!--内容-->
    <div class="product-content">
      <!--基本信息-->
      <div class="common-form">基本信息</div>
      <div class="table-wrap">
        <el-row>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">用户：</span>
              {{ detail.name }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">手机号：</span>
              {{ detail.mobile }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">提现银行：</span>
              {{ detail.bankName }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">银行卡卡号：</span>
              {{ detail.cardNumber }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">提现金额：</span>
              {{ detail.amount }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">到账金额：</span>
              {{ detail.receivedAmount }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">审核状态：</span>
              <span v-if="detail.status == 0">待审核</span>
              <span v-if="detail.status == 1">审核通过</span>
              <span v-if="detail.status == 2">审核不通过</span>
            </div>
          </el-col>
          <el-col :span="5" v-if="detail.status == 2 ">
            <div class="pb16">
              <span class="gray9">不通过原因：</span>
              {{ detail.reason }}
            </div>
          </el-col>
          <el-col :span="5" v-if="detail.status != 0">
            <div class="pb16">
              <span class="gray9">审核时间：</span>
              {{ detail.auditTime }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">申请时间：</span>
              {{ detail.createTime }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">打款状态：</span>
              {{ detail.payStatus===0?'待打款':detail.payStatus===1?'打款成功':'打款失败' }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">打款时间：</span>
              {{ detail.payTime || '--' }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">打款结果：</span>
              {{ detail.failureReason || '--'}}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">证件类型：</span>
              {{ detail.cardType}}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">证件号码：</span>
              {{ detail.card}}
            </div>
          </el-col>
          <el-col :span="5" v-if="detail.status">
            <div class="pb16">
              <span class="gray9">打款方式：</span>
              {{ detail.payType === 10?'线上':'线下'}}
            </div>
          </el-col>
        </el-row>
      <el-row v-if="detail.status">
          <el-col :span="2" style="color:#999;">打款凭证：</el-col>
          <el-col :span="20">
            <div class="imgList">
              <div class="item" v-for="(item, index) in detail.image" :key="index">
                <el-image :src="item.url" style="width:100%;height:auto" :preview-src-list="[item.url]"></el-image>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!--商品信息-->
      <div v-if="detail.status == 0">
        <div class="common-form">审核</div>
        <div class="table-wrap"></div>
        <el-row >
          <el-col style="width:120px;">审核状态：</el-col>
          <el-col :span="5">
            <div class="pb16">
              <el-radio v-model="form.type" label="pass" @change="getRadio">审核通过</el-radio>
              <el-radio v-model="form.type" label="noPass" @change="getRadio">审核不通过</el-radio>
            </div>
          </el-col>
        </el-row>
        <el-row v-if="form.type == 'noPass'">
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">不通过原因：</span>
              <el-input type="textarea" :rows="2" v-model="form.reason"></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row v-if="form.type === 'pass'">
          <el-col style="width:120px;">打款方式：</el-col>
          <el-col :span="5">
            <div class="pb16">
              <el-radio v-model="form.payType" :disabled="detail.cardType != '身份证'" label="10" >线上</el-radio>
              <el-radio v-model="form.payType" label="20">线下</el-radio>
            </div>
          </el-col>
        </el-row>
        <el-row v-if="form.payType === '20' && form.type === 'pass'">
          <el-col style="width:120px;">打款凭证：</el-col>
          <el-col :span="5">
            <div class="draggable-list">
              <draggable class="wrapper" v-model="form.image">
                <transition-group>
                  <div class="item" v-for="(item, index) in form.image" :key="item.filePath">
                    <img v-img-url="item.filePath" />
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
                  </div>
                </transition-group>
              </draggable>
              <div class="item img-select" @click="openProductUpload('image', 'image')"><i class="el-icon-plus"></i></div>
            </div>
          </el-col>
        </el-row>

        <el-row v-if="form.type == 'pass'" style="margin-bottom: 20px;">
          <el-col style="width:120px;">修改到账金额：</el-col>
          <el-col :span="8">
            <el-input-number size="mini" v-model="form.amt" :controls="false"></el-input-number>
          </el-col>
        </el-row>

        <el-row v-if="form.type == 'pass'" style="margin-bottom: 20px;">
          <el-col style="width:120px;">修改到账金额原因：</el-col>
          <el-col :span="8">
                <el-input type="textarea" :rows="2" placeholder="请输入原因" v-model="form.changeAmtReason">
                </el-input>
          </el-col>
        </el-row>

        <el-row v-if="form.type == 'pass'">
          <el-col style="width:120px;">短信验证码：</el-col>
          <el-col :span="8" style="display:flex">
            <el-input type="text" maxlength="6" size="mini" v-model="form.code" clearable style="width:100px"></el-input>
            <el-button size="mini" type="primary" :disabled="disabled" @click="gosend()">{{ disabled?(count+'s后重新发送'):text }}</el-button>
          </el-col>
        </el-row>

      </div>
    </div>
    <div class="common-button-wrapper">
      <el-button size="small" type="info" @click="cancelFunc">返回上一页</el-button>
      <!--确认发货-->
      <template v-if="detail.status == 0">
        <el-button size="small" type="primary" @click="onSubmit">提交审核</el-button>
      </template>
    </div>
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import WithdrawalApi from '@/api/withdrawal.js';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      active: 0,
      /*是否加载完成*/
      loading: true,
      /*订单数据*/
      detail: {
      },
      form:{
        type:'',
        amt: 0,
        changeAmtReason: '',
        reason:'',
        image:[],
        code:''
      },
      isProductUpload: false,
      config: {},
      file_name: 'image',
      text:'发送短信',
      count:60,
      disabled:false
    };
  },
  created() {
    /*获取列表*/
    this.getParams();
  },
  methods: {
    gosend(){
      let self = this
      if(self.disabled) return

      self.disabled = true
      WithdrawalApi.getCode().then((res) =>{
        self.$message({
            message: res.data,
            type: 'success'
          });
      })

      let timer = setInterval(() => {
        self.count--;
          if (self.count === 0) {
            clearInterval(timer);
            self.count = 60;
            self.disabled = false;
          }
        }, 1000);

    },
     /*打开上传图片*/
     openProductUpload: function(file_type, file_name) {
      this.file_name = file_name;
      if(file_type == 'image'){
        this.config = {
          total: 9,
          fileType: 'image'
        };
      }else{
        this.config = {
          total: 1,
          fileType: 'video'
        };
      }
      this.isProductUpload = true;
    },
        /*上传商品图片*/
        returnProductImgsFunc(e) {
      if (e != null) {
        if(this.file_name == 'image'){
          let imgs = this.form.image.concat(e);
          // 兼容后端
          for(let i=0;i<imgs.length;i++){
            if(typeof(imageId) == "undefined"){
              this.$set(imgs[i], 'imageId', imgs[i].fileId);
            }
          }
          this.$set(this.form, 'image', imgs);
        }
      }
      this.isProductUpload = false;
    },
    deleteImg(index) {
      this.form.image.splice(index, 1);
    },
    /*获取参数*/
    getParams() {
      let self = this;
      // 取到路由带过来的参数
      const params = this.$route.query.id;
      WithdrawalApi.withdrawalDetail(
        {
          id: params
        },
        true
      )
        .then(res => {
          self.loading = false;

          self.detail = res.data;
          self.form.amt = self.detail.receivedAmount
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*提交审核*/
    onSubmit() {
      let self = this;
      let id = this.$route.query.id;

      if ('' == self.form.type){         // 审核状态
        this.$message.error('请选择审核状态');
        return false;
      }
      if(self.form.type==='pass' && !self.form.payType){
        this.$message.error('请选择打款方式');
        return false;
      }
      if(self.form.type==='pass' && self.form.payType === '20' && self.form.image.length === 0){
        this.$message.error('请上传打款凭证');
        return false;
      }
      if(self.form.type === 'pass' && !self.form.code){
        this.$message.error('请输入6位短信验证码');
        return false;
      }
      console.log(self.form)
      let imageIds = []
      self.form.image.forEach((item) => {
        imageIds.push(item.fileId)
      })


      WithdrawalApi.onSubmit(
        {
          id: id,
          dataType: self.form.type,
          reason: self.form.reason,
          payType:parseInt(self.form.payType),
          imageIds:imageIds.join(','),
          amt: self.form.amt,
          changeAmtReason: self.form.changeAmtReason,
          accountType:self.detail.accountType,
          code:self.form.code
        },
        true
      )
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，审核成功',
            type: 'success'
          });
          self.getParams();
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },

    //监听单选按钮
    getRadio(val) {
    },
  }
};
</script>
<style>

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
.inp {
  width: 120px;
}
.imgList{
  display: flex;

}
.imgList .item{
  width:110px;
  height:110px;
  border: 1px solid #ccc;
  border-radius: 8px;
  display: flex;
  align-items: center;
  margin-right: 20px;
  overflow: hidden;

}
</style>



// WEBPACK FOOTER //
// src/views/withdrawal/withdrawal/detail.vue